import { createSlice } from "@reduxjs/toolkit";

type ApproveRejectInfoSlice = {
  fileName: string | null;
};

const initialState: ApproveRejectInfoSlice = {
  fileName: null,
};

export const ApproveRejectInfoSlice = createSlice({
  name: "ApproveRejectInfoSlice",
  initialState,
  reducers: {
    setFileName: (state, action) => {
      state.fileName = action.payload;
    },
    resetApproveRejectInfo: () => initialState,
  },
});

export const { setFileName, resetApproveRejectInfo } =
  ApproveRejectInfoSlice.actions;
export default ApproveRejectInfoSlice.reducer;
